import OaApiService from './OaApiService';

export default class SecurityService extends OaApiService {
  userLogin(data) {
    return this.post('/SecurityREST/user-login', data, null, true)
      .catch((error) => {
        if (error === 'Login failed') {
          // eslint-disable-next-line no-throw-literal
          throw ('Login / Password do not match.');
        }
        throw (error);
      });
  }

  sendResetPasswordLink(data) {
    const resetData = {
      template: 'email-agent-agent-forgot-password',
      reseturl: `${process.env.VUE_APP_OLD_AGENT_PORTAL_URL}/reset-password.php?rt={token}&sr=0`,
    };
    return this.post('/SecurityREST/forgotten-password', Object.assign({}, data, resetData));
  }

  setPassword(data) {
    return this.post('/SecurityREST/set-password', data, null, true);
  }

  updatePassword(data) {
    return this.post('/SecurityREST/change-password', data);
  }

  resetPassword(data) {
    return this.put('/securityREST/reset-password', data);
  }

  verifyUserAccount(data) {
    return this.put('/SecurityREST/verify-user-account', data, null, true);
  }

  sendDeviceOTPVerificationCode(data) {
    return this.post('/SecurityREST/create-user-verification-code', data, null, true);
  }

  verifyDeviceOTPVerificationCode(data) {
    return this.post('/SecurityREST/verify-user-verification-code', data, null, true);
  }
}
